import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
    @Input()
    public message: string;
    public dots$: Observable<any>;
    @Input()
    public error: boolean = false;
    @Input()
    public errorMessage: string;
    @Input()
    public displayPbar = false;
    @Input()
    public pBarValue: number;

    constructor() {}
    ngOnInit() {}
}
